"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiChartContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _DeviceChartContainerModule = _interopRequireDefault(require("../../styles/components/DeviceLineChart/DeviceChartContainer.module.css"));
var _SelectionBottomPanel = _interopRequireDefault(require("./SelectionBottomPanel"));
var _InformationPanel = _interopRequireDefault(require("./InformationPanel"));
var _MultiChart = _interopRequireDefault(require("./MultiChart"));
var _Calendar = require("../Calendar");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MultiChartContainer = _ref => {
  let {
    chartId,
    isPrediction,
    equipmentType,
    equipmentId
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _DeviceChartContainerModule.default.details_charts
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _DeviceChartContainerModule.default.chart_box
  }, /*#__PURE__*/_react.default.createElement(_MultiChart.default, {
    chartId: chartId,
    equipmentType: equipmentType,
    equipmentId: equipmentId,
    isPrediction: isPrediction
  }), /*#__PURE__*/_react.default.createElement(_InformationPanel.default, {
    chartId: chartId,
    equipmentType: equipmentType,
    equipmentId: equipmentId
  }), /*#__PURE__*/_react.default.createElement(_Calendar.CalendarChartWrap, {
    chartId: chartId
  })), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_SelectionBottomPanel.default, {
    chartId: chartId,
    equipmentId: equipmentId,
    equipmentType: equipmentType
  }));
};
exports.MultiChartContainer = MultiChartContainer;